var RoktTag = (function(window, document) {
    function pivot(arr) {
        if (!arr.length) {
            return {};
        }

        return arr.reduce(function(acc, row) {
            Object.keys(row).forEach(function(key) {
                acc[key] = acc[key] || [];
                acc[key].push(row[key] || '');
            });
            return acc;
        }, {});
    }

    function formatTime(timeStr){
        // hh:mm -> hhmm
        return timeStr.split(':').join('');
    }

    function formatDate(dateStr) {
        // mm/dd/yyyy -> yyyymmdd
        return dateStr.split('/').pop() + dateStr.split('/').slice(0, 2).join('');
    }

    function stripCommas(str) {
        return str.split(',').join('');
    }

    function initRokt(dataLayer, currency, eventCountryCode, firstName, lastName, phoneNumber) {
        var data = dataLayer.find(function(element) {
            return element.hasOwnProperty('ecommerce');
        });

        if (!data) {
            return;
        }

        var purchase = data.ecommerce.purchase;
        var actionField = purchase.actionField;
        var product = pivot(purchase.products);
        var rokt = [];

        rokt.push(['language', 'en']);
        rokt.push(['eventurl', window.FG.Base.labelRoot]);
        rokt.push(['currency', currency]);
        rokt.push(['eventcountry', eventCountryCode]);
        rokt.push(['firstName', firstName]);
        rokt.push(['lastName', lastName]);
        rokt.push(['mobile', phoneNumber.toString()]);
        rokt.push(['ordernumber', actionField.id]);
        rokt.push(['value', actionField.revenue]);
        rokt.push(['email', product.email[0]]);
        rokt.push(['postcode', product.billingZip[0]]);
        rokt.push(['state', product.billingState[0]]);
        rokt.push(['country', product.countryCode[0]]);
        rokt.push(['confirmationref', actionField.id]);
        rokt.push(['eventid', product.labelId[0]]);
        rokt.push(['eventzipcode', product.venueZip.join(',')]);
        rokt.push(['eventname', stripCommas(product.labelName[0])]);
        rokt.push(['eventvenue', product.venueName
            .map(function(name){
                return stripCommas(name);
            })
            .join(',')
        ]);
        rokt.push(['eventdate', product.eventDate
            .map(function(date){
                return formatDate(date);
            })
            .join(',')
        ]);
        rokt.push(['eventtime', product.eventTime
            .map(function(time){
                return formatTime(time);
            })
            .join(',')
        ]);
        rokt.push(['numberofitems', product.quantity
            .map(function(item) {
                return parseInt(item, 10);
            })
            .reduce(function(total, num) {
                return total + num;
            }, 0)
            .toString()
        ]);

        var blankItems = [
            'paymenttype',
            'ccbin',
            'gender',
            'age',
            'dob',
            'unitno',
            'address1',
            'address2',
            'city',
            'venueid',
            'eventcity',
            'eventstate',
            'eventdurationminutes',
            'eventimage'
        ].map(function(dataField) {
            return [dataField, ''];
        });

        window._ROKT = window._ROKT || [];
        window._ROKT = window._ROKT.concat(rokt, blankItems);
        if (eventCountryCode == 'GB'){
            var roktTagID = 'eda1486196164fe2bb370683b66472f6';
        } else {
            var roktTagID = 'c154fce2cc4d44b9b974afadd1a73b93';
        }
        console.log("roktTagId=" + roktTagID);
        var js = document.createElement('script');
        js.type = 'text/javaScript';
        js.async = true;
        js.src = 'https://apps.rokt.com/?id=' + roktTagID + '&bhid=' + roktTagID + '-b&v=' + Math.floor(Math.random() * 999).toString();

        var p = document.getElementsByTagName('script')[0];
        p.parentNode.insertBefore(js, p);
    }

    return {
        init: initRokt
    };
}(window, document));
